import CloseIcon from '@mui/icons-material/Close'
import {
  StyledDeleteButton,
  StyledDialogTitle,
  StyledDialogContent,
  StyledIconButton,
  CancelRemoveUserButton,
  StyledTitleWarningIcon,
  StyledDivCenter,
  StyledDivFooter,
  StyledUserDetail,
  StyledWarningFooter,
  StyledFooterWarningIcon,
  StyledTitleRow,
  StyledButtonGroup,
  StyledDialog
} from './RemoveUserStyles'
import PopupMessages from '../../common/PopupMessages/PopupMessages.json'
import PropTypes from 'prop-types'

const RemoveUserComponent = ({open, setOpen, data, handleDeleteUser}) => {
  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = async () => {
    setOpen(false)
    handleDeleteUser(data.EMAIL_ID)
  }

  return (
    <StyledDialog maxWidth='sm' onClose={handleClose} aria-labelledby='customized-dialog-title' open={open}>
      <StyledDialogTitle id='customized-dialog-title'>
        <StyledTitleRow>
          <StyledTitleWarningIcon />
          {PopupMessages.deleteUserTitle}
        </StyledTitleRow>
        <StyledIconButton aria-label='close' onClick={handleClose}>
          <CloseIcon />
        </StyledIconButton>
      </StyledDialogTitle>
      <StyledDialogContent>
        <StyledDivCenter tabIndex={0} aria-label={PopupMessages.deleteUserConfirmationText}>
          {PopupMessages.deleteUserConfirmationText}
        </StyledDivCenter>
        <StyledUserDetail tabIndex={0} aria-label={`Username: ${data.FIRST_NAME} ${data.LAST_NAME}`}>
          Username: {data.FIRST_NAME} {data.LAST_NAME}
        </StyledUserDetail>
        <StyledUserDetail tabIndex={0} aria-label={`User Email: ${data.EMAIL_ID}`}>
          User Email: {data.EMAIL_ID}
        </StyledUserDetail>
        <StyledDivFooter>
          <StyledWarningFooter>
            <StyledFooterWarningIcon />
            {PopupMessages.deleteUserConfirmationBody}
          </StyledWarningFooter>
          <StyledButtonGroup>
            <CancelRemoveUserButton aria-label='cancel' onClick={handleClose}>
              Cancel
            </CancelRemoveUserButton>
            <StyledDeleteButton aria-label={`delete-user, ${data.EMAIL_ID}`} onClick={handleDelete}>
              {PopupMessages.deleteButtonText}
            </StyledDeleteButton>
          </StyledButtonGroup>
        </StyledDivFooter>
      </StyledDialogContent>
    </StyledDialog>
  )
}

RemoveUserComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  handleDeleteUser: PropTypes.func.isRequired
}
export default RemoveUserComponent
